import {
  Button,
  Drawer,
  Grid,
  makeStyles,
  Paper,
  TablePagination,
  Typography,
} from "@material-ui/core";
import { CheckCircleRounded, FilterList } from "@material-ui/icons";
import LoupeIcon from "@material-ui/icons/Loupe";
import { format } from "date-fns";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useMinuteList } from "../../../context/lists/minuteList";
import { useCommittees } from "../../../hooks/useCommittees";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { exportMinuteFile, getAll } from "../../../services/minutes.service";
import {
  getDateFormats,
  getDateTimeLocale,
} from "../../../utils/get-date-time-locale";
import { Table } from "../../Common/Table";
import Toastmessage from "../../Common/ToastMessage";
import { getSlotStatus } from "../../Pages/utils/index";
import { checkAccess } from "../utils/index";
import ModalBase from "../utils/ModalBase";
import ConfirmAttendanceModal from "./ConfirmAttendanceModal";
import CustomGroupRow from "./CustomGroupRow";
import EditAction from "./EditAction";
import ExportMinuteFileModal from "./ExportMinuteFileModal";
import FilterDrawer from "./FilterDrawer";
import MinuteDocsSentToSignModal from "./MinuteDocsSentToSignModal";
import SendToSignatureConfirmModal from "./SendToSignatureConfirmModal";
import UpdateMinuteStatusModal from "./UpdateMinuteStatusModal";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
    width: "100%",
  },
  paper: {
    padding: 16,
    width: "100%",
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  subtitle: {
    ...theme.typography.subtitle1,
  },
  filterButton: {
    ...theme.typography.subtitle1,
    backgroundColor: "#fff",
    color: "#666666",
    borderRadius: 8,
    border: "1px solid #666666",
    textTransform: "uppercase",
    maxWidth: 140,
    width: "100%",
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
}));

const Minutes = ({ t, history, actionShowSpinner }) => {
  const columns = [
    {
      title: "ata",
      field: "ata",
      defaultGroupOrder: 0,
      grouping: true,
    },
    {
      title: t("forms.committeeName").toUpperCase(),
      field: "committee",
    },
    {
      title: t("forms.meetDate").toUpperCase(),
      field: "meetDate",
    },
    {
      title: t("forms.slotTheme").toUpperCase(),
      field: "slotTheme",
    },
    {
      title: t("slots.companies").toUpperCase(),
      field: "companies",
      render: (rowData) =>
        rowData.companies
          ? rowData.companies.map((cp) => cp.companyName).join(", ")
          : "-",
    },
    {
      title: t("forms.requester").toUpperCase(),
      field: "requester",
    },
  ];
  const classes = useStyles();
  const { i18n } = useTranslation();
  const { getActiveCommitteesByLanguageId } = useCommittees({
    spinner: actionShowSpinner,
  });
  const { userAccess } = useAuth();
  const { listOptions, updateFilterParams, updatePagination, expandedMinuteIds, setExpandedMinuteIds } = useMinuteList();

  const [minutes, setMinutes] = useState([]);
  const [minuteIdToUpdateStatus, setMinuteIdToUpdateStatus] = useState();
  const [totalMinutes, setTotalMinutes] = useState(0);
  const [minuteIdToSeeDocsSentToSign, setMinuteIdToSeeDocsSentToSign] =
    useState();
  const [minuteDocsSentToSignModalOpened, setMinuteDocsSentToSignModalOpened] =
    useState(false);
  const [openUpdateMinuteStatusModal, setOpenUpdateMinuteStatusModal] =
    useState(false);
  const [minuteForAttendancesModal, setMinuteForAttendancesModal] = useState();
  const [openConfirmAttendanceModal, setOpenConfirmAttendanceModal] =
    useState(false);
  const [minuteIdForExportFile, setMinuteIdForExportFile] = useState(null);
  const [minuteCompaniesForExportFile, setMinuteCompaniesForExportFile] =
    useState([]);
  const [
    minuteCompaniesForConfirmParticipants,
    setMinuteCompaniesForConfirmParticipants,
  ] = useState([]);
  const [showStatusUpdatedMessage, setShowStatusUpdatedMessage] =
    useState(false);
  const [successSetAttendance, setSuccessSetAttendance] = useState(false);
  const [openExportMinuteFile, setOpenExportMinuteFile] = useState(false);
  const [openSendToSignatureConfirmModal, setOpenSendToSignatureConfirmModal] =
    useState(false);
  const [canConfirmParticipants, setCanConfirmParticipants] = useState(false);
  const [canCreateExtraSlot, setCanCreateExtraSlot] = useState(false);
  const [canExportMinuteFile, setCanExportMinuteFile] = useState(false);
  const [canUpdateMinuteStatus, setCanUpdateMinuteStatus] = useState(false);
  const [canSendFileToSignature, setCanSendFileToSignature] = useState(false);
  const [canListDocumentsSentToSign, setCanListDocumentsSentToSign] =
    useState(false);
  const [canListDocumentSignatures, setCanListDocumentSignatures] =
    useState(false);
  const [minuteIdSendignToSignature, setMinuteIdSendingToSignature] =
    useState();

  const [slotForEdit, setSlotForEdit] = useState();
  const [editActionModalOpened, setEditActionModalOpened] = useState(false);

  const [filterDrawerOpened, setFilterDrawerOpened] = useState(false);

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });

  const loadMinutes = useCallback(() => {
    actionShowSpinner(true);
    getAll({
      ...(listOptions.filterParams?.minuteStatus && {
        statusAta: listOptions.filterParams?.minuteStatus.map(
          (status) => status.id
        ),
      }),
      ...(listOptions.filterParams?.committees && {
        committeeId: listOptions.filterParams?.committees.map(
          (committee) => committee.id
        ),
      }),
      ...(listOptions.filterParams?.startDate && {
        startDate: listOptions.filterParams.startDate,
      }),
      ...(listOptions.filterParams?.companies && {
        companyIds: listOptions.filterParams?.companies.map((cp) => cp.id),
      }),
      ...(listOptions.filterParams?.endDate && {
        endDate: listOptions.filterParams.endDate,
      }),
      ...(listOptions.filterParams?.requester && {
        requesterId: listOptions.filterParams?.requester?.id,
      }),
      ...(listOptions.filterParams?.keyword?.length > 0 &&
        listOptions.filterParams?.keyword && {
          keyword: listOptions.filterParams.keyword,
        }),
      pageSize: listOptions.pagination.size,
      currentPage: listOptions.pagination.page,
    })
      .then((result) => {
        setMinutes(result.items);
        setTotalMinutes(result.countItems);
      })
      .catch(() => setMinutes([]))
      .finally(() => {
        actionShowSpinner(false);
      });
  }, [listOptions]);

  useEffect(() => {
    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "listMinutes");
      const hasAccessToConfirmParticipants = checkAccess(
        userAccess,
        "confirmParticipants"
      );
      const hasAccessToCreateExtraSlot = checkAccess(
        userAccess,
        "createExtraSlot"
      );
      const hasAccessToUpdateMinuteStatus = checkAccess(
        userAccess,
        "updateMinuteStatus"
      );
      const hasAccessToExportMinuteFile = checkAccess(
        userAccess,
        "exportMinute"
      );
      const hasAccessToSendFileToSignature = checkAccess(
        userAccess,
        "sendFileToSignature"
      );
      const hasAccessToListDocumentsSentToSign = checkAccess(
        userAccess,
        "listDocumentsSentToSign"
      );
      const hasAccessToListDocumentSignatures = checkAccess(
        userAccess,
        "listDocumentSignatures"
      );

      setCanConfirmParticipants(hasAccessToConfirmParticipants);
      setCanCreateExtraSlot(hasAccessToCreateExtraSlot);
      setCanUpdateMinuteStatus(hasAccessToUpdateMinuteStatus);
      setCanExportMinuteFile(hasAccessToExportMinuteFile);
      setCanListDocumentsSentToSign(hasAccessToListDocumentsSentToSign);
      setCanListDocumentSignatures(hasAccessToListDocumentSignatures);
      setCanSendFileToSignature(hasAccessToSendFileToSignature);

      if (!hasAccess) {
        history.push("/");
      }

      getActiveCommitteesByLanguageId(i18n.language).then(() => {
        loadMinutes();
      });
    }
  }, [actionShowSpinner, loadMinutes, userAccess, history, i18n.language]);

  const formattedMinutes = useMemo(() => {
    let newMinutes = [];

    if (!minutes) {
      return newMinutes;
    }
    newMinutes = minutes?.map((slot) => ({
      idSlot: slot.idSlot,
      idMinuteSlot: slot.idMinuteSlot,
      ata: slot.idAta,
      committee: slot.committeeName,
      companies: slot.companies,
      committeeId: slot.committeeId,
      meetDate: format(new Date(slot.meetDate), getDateFormats(i18n.language), {
        locale: getDateTimeLocale(i18n.language),
      }),
      meetDateOriginal: new Date(slot.meetDate),
      meetId: slot?.meetId,
      extraSlot: !!slot?.extraSlot,
      slotTheme: slot.theme,
      order: Number(slot.slotOrder),
      roundRobin: slot.roundRobin,
      requester: slot.requester,
      objective: slot.objective,
      modality: slot.modality,
      comitteeSlotId: slot.idSlotComittee,
      status: getSlotStatus(slot.status, localStorage.getItem("i18nextLng")),
      minuteStatus: slot.statusAta,
      slotType: slot.slotType,
    }));

    return newMinutes.sort((a, b) => a.order - b.order);
  }, [minutes]);

  const handleExportMinuteFile = async (companies) => {
    try {
      const response = await exportMinuteFile(
        minuteIdForExportFile,
        companies.map((sc) => sc.id)
      );

      const minute = formattedMinutes.find(
        (minute) => minute.ata === minuteIdForExportFile
      );

      const companiesLabel = companies
        .map((company) => company.abbreviation)
        .join(", ");
      let fileName = `${minute.committee} - ${minute.meetDate} - ${companiesLabel} - Ata.pdf`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);

      link.click();
    } catch (e) {
      const errorReponse = await e.response.data.text();
      const { errors } = JSON.parse(errorReponse);

      const formattedErrorMessage =
        errors[0] ?? t("menu.minutes.exportMinuteError");

      setMessage({
        open: true,
        content: formattedErrorMessage,
        type: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setOpenExportMinuteFile(false);
    }
  };

  const handleSuccessUpdateMinuteStatus = useCallback(() => {
    actionShowSpinner(true);

    setOpenUpdateMinuteStatusModal(false);

    loadMinutes();

    setShowStatusUpdatedMessage(true);
  }, [
    actionShowSpinner,
    setOpenUpdateMinuteStatusModal,
    loadMinutes,
    setShowStatusUpdatedMessage,
  ]);

  const handleCloseEditAction = useCallback(() => {
    setEditActionModalOpened(false);
  }, [setEditActionModalOpened]);

  return (
    <>
      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <ModalBase
        open={editActionModalOpened}
        setOpen={(value) => {
          if (!value) {
            handleCloseEditAction();
          }
        }}
        content={
          <EditAction
            slotId={slotForEdit?.idSlot}
            minuteId={slotForEdit?.ata}
            minuteSlotId={slotForEdit?.idMinuteSlot}
            comitteeSlotId={slotForEdit?.comitteeSlotId}
            slotType={slotForEdit?.slotType}
            onClose={handleCloseEditAction}
          />
        }
      />
      <ModalBase
        open={openSendToSignatureConfirmModal}
        setOpen={setOpenSendToSignatureConfirmModal}
        maxWidth={"md"}
        content={
          <SendToSignatureConfirmModal
            setSendToSignatureConfirmModal={setOpenSendToSignatureConfirmModal}
            minuteId={minuteIdSendignToSignature}
            setMessage={setMessage}
            onSuccess={handleSuccessUpdateMinuteStatus}
          />
        }
      />
      <ModalBase
        open={openExportMinuteFile}
        setOpen={setOpenExportMinuteFile}
        content={
          <ExportMinuteFileModal
            committeeId={
              formattedMinutes?.find((m) => m.ata === minuteIdForExportFile)
                ?.committeeId
            }
            setExportMinuteFileModalOpened={setOpenExportMinuteFile}
            handleExportMinuteFile={handleExportMinuteFile}
            minuteCompaniesForExportFile={minuteCompaniesForExportFile}
            t={t}
          />
        }
      />
      {/* <DialogCustom
        open={openExportMinuteFile}
        handleClose={() => setOpenExportMinuteFile(false)}
        handleChange={handleExportMinuteFile}
        title={t(`forms.dialog.alert`)}
        body={t("forms.minutes.exportMinuteFileQuestion")}
        confirmText={t(`forms.dialog.yes`)}
        cancelText={t(`forms.dialog.no`)}
        alert={true}
      /> */}
      <ModalBase
        open={minuteDocsSentToSignModalOpened}
        setOpen={setMinuteDocsSentToSignModalOpened}
        content={
          <MinuteDocsSentToSignModal
            minuteId={minuteIdToSeeDocsSentToSign}
            setModalStatus={(value) =>
              setMinuteDocsSentToSignModalOpened(value)
            }
            actionShowSpinner={(opened) => actionShowSpinner(opened)}
          />
        }
      />
      <ModalBase
        open={openUpdateMinuteStatusModal}
        setOpen={setOpenUpdateMinuteStatusModal}
        content={
          <UpdateMinuteStatusModal
            t={t}
            setToastMessage={setMessage}
            setModalStatus={(value) => setOpenUpdateMinuteStatusModal(value)}
            onSuccess={handleSuccessUpdateMinuteStatus}
            minuteId={minuteIdToUpdateStatus}
            currentMinuteStatus={
              formattedMinutes?.find((m) => m.ata === minuteIdToUpdateStatus)
                ?.minuteStatus
            }
            isRoundRobinMeet={
              formattedMinutes?.find((m) => m.ata === minuteIdToUpdateStatus)
                ?.roundRobin
            }
          />
        }
      />
      <ModalBase
        open={openConfirmAttendanceModal}
        setOpen={setOpenConfirmAttendanceModal}
        content={
          <ConfirmAttendanceModal
            t={t}
            setModalStatus={(value) => setOpenConfirmAttendanceModal(value)}
            companiesOptions={
              minuteCompaniesForConfirmParticipants
                ? minuteCompaniesForConfirmParticipants
                : []
            }
            onSuccess={() => {
              setOpenConfirmAttendanceModal(false);
              setSuccessSetAttendance(true);

              setTimeout(() => {
                setSuccessSetAttendance(false);
              }, 4000);
            }}
            minuteId={minuteForAttendancesModal?.ata}
          />
        }
      />
      <Drawer
        anchor="right"
        open={filterDrawerOpened}
        onClose={() => {
          setFilterDrawerOpened(false);
        }}
      >
        <FilterDrawer
          actionShowSpinner={(opened) => actionShowSpinner(opened)}
          onClose={() => {
            setFilterDrawerOpened(false);
          }}
          t={t}
          setFilters={(newValues) => {
            updateFilterParams(newValues);
            updatePagination({ ...listOptions.pagination, page: 0 });
          }}
          filters={listOptions.filterParams}
        />
      </Drawer>
      <Grid container className={classes.root} style={{ width: "100%" }}>
        <Grid
          container
          item
          direction="row"
          justify="space-between"
          className={classes.spacer}
        >
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h4">{t("forms.minutes.title")}</Typography>
          </Grid>
        </Grid>
        <Paper elevation={1} className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item lg={12}>
              <Button
                className={classes.filterButton}
                startIcon={<FilterList style={{ fontSize: 30 }} />}
                onClick={() => setFilterDrawerOpened(true)}
              >
                {t("forms.filters")}
              </Button>
            </Grid>

            <Grid item lg={12} xs={12}>
              <Table
                columns={columns}
                data={formattedMinutes}
                actions={[
                  (rowData) => ({
                    icon: () => <LoupeIcon />,
                    tooltip: t("preview"),
                    disabled:
                      rowData.minuteStatus === "NI" ||
                      rowData.minuteStatus === "EA",
                    onClick: (_event, rowData) => {
                      setSlotForEdit(rowData);
                      setEditActionModalOpened(true);
                    },
                  }),
                ]}
                pageSize={listOptions.pagination.size}
                components={{
                  GroupRow: (rowData) => {
                    return (
                      <CustomGroupRow
                        {...rowData}
                        groupData={{...rowData.groupData, isExpanded: expandedMinuteIds.includes(rowData.groupData.data[0].ata)}}
                        t={t}
                        onConfirmAttendance={() => {
                          if (
                            rowData.groupData.data[0].minuteStatus === "C" ||
                            rowData.groupData.data[0].minuteStatus === "NI" ||
                            !canConfirmParticipants
                          ) {
                            return;
                          }

                          const allMinuteCompanies = rowData.groupData.data
                            .map((gd) => gd.companies)
                            .flat();

                          const uniqueMinuteCompanies =
                            allMinuteCompanies.reduce((acc, curr) => {
                              if (
                                !acc?.find(
                                  (a) => a.companyId === curr.companyId
                                )
                              ) {
                                acc.push(curr);
                              }

                              return acc;
                            }, []);

                          setMinuteCompaniesForConfirmParticipants(
                            uniqueMinuteCompanies
                          );

                          setMinuteForAttendancesModal(
                            rowData.groupData.data[0]
                          );
                          setOpenConfirmAttendanceModal(true);
                        }}
                        handleGroupExpandChanged={() => {
                          setExpandedMinuteIds(prevState => {
                            if(prevState.includes(rowData.groupData.data[0].ata)){
                              return prevState.filter(id => id !== rowData.groupData.data[0].ata);
                            } else {
                              return [...prevState, rowData.groupData.data[0].ata];
                            }
                          });
                        }}
                        updateStatus={() => {
                          if (rowData.groupData.data[0].minuteStatus === "C") {
                            return;
                          }

                          setMinuteIdToUpdateStatus(
                            rowData.groupData.data[0].ata
                          );
                          setOpenUpdateMinuteStatusModal(true);
                        }}
                        exportMinuteFIle={() => {
                          setMinuteIdForExportFile(
                            rowData.groupData.data[0].ata
                          );

                          const allMinuteCompanies = rowData.groupData.data
                            .map((gd) => gd.companies)
                            .flat();

                          const uniqueMinuteCompanies =
                            allMinuteCompanies.reduce((acc, curr) => {
                              if (
                                !acc?.find(
                                  (a) => a.companyId === curr.companyId
                                )
                              ) {
                                acc.push(curr);
                              }

                              return acc;
                            }, []);

                          setMinuteCompaniesForExportFile(
                            uniqueMinuteCompanies
                          );
                          setOpenExportMinuteFile(true);
                        }}
                        createExtraSlot={() => {
                          history.push({
                            pathname: "/slot/new",
                            state: {
                              extraSlot: true,
                              extraSlotInfo: {
                                defaultDate:
                                  rowData.groupData.data[0].meetDateOriginal,
                                committee: {
                                  id: rowData.groupData.data[0].committeeId,
                                  nameCommittee:
                                    rowData.groupData.data[0].committee,
                                  finalAuthority: true,
                                },
                              },
                            },
                          });
                        }}
                        canConfirmParticipants={
                          canConfirmParticipants &&
                          rowData.groupData.data[0].minuteStatus !== "NI" &&
                          rowData.groupData.data[0].minuteStatus !== "EA"
                        }
                        canExportMinuteFile={canExportMinuteFile}
                        canUpdateMinuteStatus={
                          canUpdateMinuteStatus &&
                          rowData.groupData.data[0].minuteStatus !== "C"
                        }
                        canCreateExtraSlot={
                          canCreateExtraSlot &&
                          rowData.groupData.data[0].minuteStatus === "E" &&
                          rowData.groupData.data[0].minuteStatus !== "EA"
                        }
                        canSendFileToSignature={
                          canSendFileToSignature &&
                          rowData.groupData.data[0].minuteStatus !== "NI" &&
                          rowData.groupData.data[0].minuteStatus !== "C" &&
                          rowData.groupData.data[0].minuteStatus !== "EA"
                        }
                        sendFileToSignature={() => {
                          setMinuteIdSendingToSignature(
                            rowData.groupData.data[0].ata
                          );
                          setOpenSendToSignatureConfirmModal(true);
                        }}
                        canSeeDocuments={canListDocumentsSentToSign}
                        handleViewDocuments={() => {
                          setMinuteIdToSeeDocsSentToSign(
                            rowData.groupData.data[0].ata
                          );
                          setMinuteDocsSentToSignModalOpened(true);
                        }}
                      />
                    );
                  },
                  Pagination: (props) => {
                    return (
                      <TablePagination
                        style={{ float: "right" }}
                        rowsPerPageOptions={[5, 10, 20]}
                        rowsPerPage={listOptions.pagination.size}
                        page={listOptions.pagination.page}
                        labelRowsPerPage={t("table.labelRowsPerPage")}
                        labelDisplayedRows={(_data) => {
                          let numberOfPages = Math.ceil(
                            totalMinutes / listOptions.pagination.size
                          );

                          if (numberOfPages <= 1) {
                            numberOfPages = 1;
                          }

                          return `${listOptions.pagination.page + 1} ${t(
                            "table.labelDisplayedRows"
                          )} ${numberOfPages}`;
                        }}
                        onPageChange={(_e, page) => {
                          updatePagination({
                            page: page,
                            size: listOptions.pagination.size,
                          });
                        }}
                        onRowsPerPageChange={(event) => {
                          const newSize = event.target.value;

                          updatePagination({
                            page: 0,
                            size: newSize,
                          });

                          props.onChangeRowsPerPage(event);
                        }}
                        nextIconButtonProps={{
                          disabled:
                            listOptions.pagination.page + 1 >=
                            Math.ceil(
                              totalMinutes / listOptions.pagination.size
                            ),
                        }}
                        backIconButtonProps={{
                          disabled: listOptions.pagination.page <= 0,
                        }}
                      />
                    );
                  },
                }}
              />
            </Grid>

            <Grid item lg={12}>
              {showStatusUpdatedMessage && (
                <Grid
                  style={{
                    width: "100%",
                  }}
                  container
                  item
                  direction="row"
                  alignItems="center"
                  justify="center"
                  className={classes.success}
                >
                  <Grid item>
                    <CheckCircleRounded className={classes.icon} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      {t("editSuccess")}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {successSetAttendance && (
                <Grid
                  style={{
                    width: "100%",
                  }}
                  container
                  item
                  direction="row"
                  alignItems="center"
                  justify="center"
                  className={classes.success}
                >
                  <Grid item>
                    <CheckCircleRounded className={classes.icon} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      {t("menu.minutes.confirmAttendance.success")}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

const withRouterMinutes = withRouter(Minutes);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const MinutesConnect = connect(null, mapDispatchToProps)(withRouterMinutes);

export default withTranslation()(MinutesConnect);
